import React, { memo } from 'react'
import { Stack, Grid } from '@mui/material'
import { faGift } from '@fortawesome/pro-light-svg-icons'

import BaseCard from '../shared/baseCard/BaseCard'
import Text from '../shared/text/Text'
import stakingBanner from '../../assets/images/staking.png'
import CustomAlert from '../shared/CustomAlert/CustomAlert'
import { transWithArgs } from '../../util/validation.helpers'
import CustomButton from '../shared/buttons/CustomButton'
import { MAIN_PROFILE_DISPATCH } from '../../store/reducers/main'
import StakingStats from './StakingStats'
import DefaultText from '../shared/text/DefaultText'
import { STATIC_REWARD_APY } from '../../constants/app'
import { sumAvailableClaimStats } from '../../util/claim.helpers'

const Staking = ({
  t,
  onClaimStake,
  dispatchAction,
  mainProfile: {
    error,
    claimStakeProcessing,
    contractsForClaim,
    claimStake: { available, loading }
  }
}) => {
  const claimStakeError = error[MAIN_PROFILE_DISPATCH.CLAIM_STAKE]
  return (
    <BaseCard>
      <Stack
        spacing={2}
        direction={{ xs: 'column', md: 'row' }}
        sx={{ alignItems: { md: 'center' } }}
      >
        <img src={stakingBanner} height={232} width={232} />
        <Grid container sx={{ alignItems: 'center' }}>
          <Grid item xs={12}>
            <Text
              variant='h2'
              label={t('staking.staking-title')}
              fontWeight={700}
              sx={{ mb: 1 }}
            />
            <DefaultText
              label={t('staking.staking-desc', { value: STATIC_REWARD_APY })}
              sx={{ fontSize: 18, mb: 3 }}
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <StakingStats
              t={t}
              total={sumAvailableClaimStats(contractsForClaim)}
              available={available}
              loading={loading}
              isDescLarge
              gridSize={4}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Stack
              spacing={2}
              sx={{ alignItems: { md: 'flex-end', xs: 'start' } }}
            >
              <CustomButton
                onClick={onClaimStake}
                icon={faGift}
                label={t('staking.claim-reward')}
                disabled={!(available > 0) || claimStakeProcessing}
                autoWidth
              />
            </Stack>
          </Grid>
        </Grid>
      </Stack>
      {(claimStakeProcessing || claimStakeError) && (
        <CustomAlert
          info={claimStakeProcessing && t('home.transaction-processing')}
          error={claimStakeError && transWithArgs(t, claimStakeError)}
          onTimeOut={
            claimStakeProcessing
              ? () => {
                  dispatchAction(
                    MAIN_PROFILE_DISPATCH.CLAIM_STAKE_PROCESSING,
                    false
                  )
                }
              : null
          }
          sx={{ mt: 2 }}
        />
      )}
    </BaseCard>
  )
}

export default memo(Staking)
